import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import OwlCarousel from "react-owl-carousel";
import ReactImageMagnify from "react-image-magnify";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Footer from "../components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { FaRegHeart, FaHeart } from "react-icons/fa6";
import axios from "axios";
import { gettoken } from "../Localstorage/Store";
import Recentlyowl from "../components/Recentlyowl";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addwishlist } from "../store/state/wishlist";
import { Field, Form, Formik } from "formik";
import { checkoutvalidation } from "../Validation/Checkout";
import { getCode } from "country-list";
import { addItem } from "../store/state/cart";
import Loader from "../components/Loader";
import Relatedowl from "../components/Relatedowl";

const options5 = {
  items: 1,
  loop: false,
  autoplay: true,
  nav: true,
  responsiveClass: true,
  dots: false,
  responsive: {
    1200: {
      items: 5,
      loop: false,
      // stagePadding: 50,
    },
    920: {
      items: 4,
      loop: false,
    },
    700: {
      items: 3,
      loop: false,
    },
    600: {
      items: 3,
      loop: false,
    },
    504: {
      items: 2,
      loop: false,
    },
    300: {
      items: 2,
      loop: false,
    },
    310: {
      items: 1,
      loop: false,
    },
  },
};
function Productdetails() {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [hover, setHover] = useState([false, null]);
  const hoverRef = useRef(hover);
  const buttonRef = useRef(null);
  const [viewimg, setviewimg] = useState(null);
  const [qty, setqty] = useState(1);
  const gobalvariable = useSelector(state => state);
  const dispatch = useDispatch();
  const [loading, setloading] = useState(true);
  const [addressstatus, setaddressstatus] = useState(false);
  const [delto, setdelto] = useState("");
  const [Data, setData] = useState([]);
  const [fixedData, setfixedData] = useState([]);
  const [Data3, setData3] = useState([]);
  const [popstatus, setpopstatus] = useState(false);
  const [attrlist, setattrlist] = useState([]);
  const [wishlist, setwishlist] = useState([]);
  const [delresponse, setdelresponse] = useState({ status: false, msg: "" });
  const [countriesdata, setcountriesdata] = useState([]);
  const checkpin = useRef(null);
  const location = useLocation();
  const nvg = useNavigate();
  const tokenvalue = gettoken();
  const [addressdataindex, setaddressdataindex] = useState(null)
  const searchString = `${process.env.REACT_APP_API_URL}media/`;
  const pathname = location.pathname;

  const parts = pathname.split("/");

  const productid = location?.state?.id;
  const productpname = location?.state?.pname;



  const customSizeOrder = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];
  const sortsizefilter = (sizes) => {
    return sizes.sort((a, b) => {
      return customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b);
    });
  }


  // Recently viewed and Product View api Start here 
  const [RecentlyViewData, setRecentlyViewData] = useState([])
  async function Recently_ViewAnd_Product_View(id) {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      const viewdata = { product_id: id }
      let url_view = `${process.env.REACT_APP_API_URL}cartapi/product-view/`;  // product_view 
      let url_recently = `${process.env.REACT_APP_API_URL}cartapi/recently-viewed/`;  // Recently view
      const response = await axios.post(url_view, viewdata, config);
      const response_recently = await axios.get(url_recently, config);
      setRecentlyViewData(response_recently.data.recently_viewed)

    } catch (error) {
      console.log("error", error)
    }
  }
  // Recently viewed and Product View api End here 

  const handleMouseEnter = (data) => {
    setHover((prevState) => {
      const updatedState = [true, data];
      hoverRef.current = updatedState;
      return updatedState;
    });
  };

  const handleMouseleave = () => {

    setHover((prevState) => {
      const updatedState = false
      hoverRef.current = updatedState;

      return updatedState;
    });

  };

  function getProductByAttribute(products, attributeName, attributeValue) {
    const remainingAttributes = Data.attributes.filter(attr => attr.attribute__name !== attributeName);
    console.log("check again and again", remainingAttributes, "fghjhhhh", Data.attributes)
    console.log("check again and again again again", products)
    const matchedVariant = products.find(product => {
      return remainingAttributes.every(attr => {
        const productAttr = product.attributes.find(pAttr => pAttr.attribute__name === attr.attribute__name);
        return productAttr && productAttr.value_option__option === attr.value_option__option;
      }) && product.attributes.some(attr => attr.attribute__name === attributeName && attr.value_option__option === attributeValue);
    });
    console.log("check again image", matchedVariant)
    const sortedImages = matchedVariant.image.sort((a, b) => a.display_order - b.display_order);
    setviewimg(`${process.env.REACT_APP_API_URL}media/${sortedImages?.[0]?.original}`);
    setData({ sortedImages, ...matchedVariant });

  }

  const handleClick = () => {
    const buttonNode = buttonRef.current;
    if (buttonNode) {
      buttonNode.click();
    }
  };


  const createaddress = async (values, setFieldError) => {

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      const formdata = new FormData();
      formdata.append("first_name", values.first_name);
      formdata.append("last_name", values.last_name);
      formdata.append("phone_number", `+91${values.mobile}`);
      formdata.append("line1", values.address1);
      formdata.append("line2", values.address2);
      formdata.append("country", getCode(values.country));
      formdata.append("state", values.state);
      formdata.append("email", values.email);
      formdata.append("line4", values.city);
      formdata.append("postcode", values.pincode);
      formdata.append("address_type", values.address_type);
      if (tokenvalue.msg == "Voucher login") {
        formdata.append("user", tokenvalue.user_id);
      } else {
        formdata.append("user", tokenvalue.id);
      }
      // setloading(true)
      // let url = `${process.env.REACT_APP_API_URL}api/useraddresses/`;
      let url = `${process.env.REACT_APP_API_URL}homepageapi/address/create/`;
      const response = await axios.post(url, formdata, config);
      if (response.data?.id) {
        // console.log("reespnse ravi vffdddrredd",response.data)
        getaddress()
        setaddressstatus(true)
        setTimeout(() => {
          setaddressstatus(false)
          handleClick()
        }, 3000);
      } else {

      }
    } catch (error) {
      setFieldError('mobile', error.response.data.phone_number[0])
    }


  }

  const [cityna, setcityna] = useState("")
  const fetchstateandcity = async (value, setFieldError, setFieldValue) => {
    if (value.length == 6) {
      try {
        let url = `${process.env.REACT_APP_API_URL}my_api/get-postcode-information/?postal_code=${value}`;
        const response = await axios.get(url);
        // setFieldValue("city", response.data.city);
        if (response.data.city == "NA") {
          setFieldValue('city', '');
          setcityna("NA");
          setFieldError('city', "Please Enter Your City")
        } else {
          setFieldValue('city', response.data.city);
          setcityna("");
        }
        setFieldValue("state", response.data.state);
        const countrydata = countriesdata.filter(
          (item2) => item2.printable_name == response.data.country.trim()
        );
        // console.log(";;;;;;", countrydata);
        setFieldValue("country", countrydata[0].printable_name);
        setFieldValue("countryurl", countrydata[0].url);
      } catch (error) {
        setFieldError("pincode", error.response.data.message);
      }
    } else {
      setFieldValue("city", "");
      setFieldValue("state", "");
      setFieldValue("country", "");
      setFieldValue("countryurl", "");
    }
  };

  const [checkloader, setcheckloader] = useState(false)
  const devto = async (itemid) => {
    if (delto == "") {
      setdelresponse({ status: true, color: "red", msg: "Deliver to field is required" });
    } else {
      setcheckloader(true)
      try {
        const formdata = new FormData();
        formdata.append("qty", qty);
        formdata.append("pin_code", delto);
        formdata.append("product_id", itemid);
        let url = `${process.env.REACT_APP_API_URL}ship/check-available/`;
        const response = await axios.post(url, formdata);
        // console.log("response of picode api",response);
        if (response.data.data == "delvery available") {

          let url2 = `${process.env.REACT_APP_API_URL}ship/get_single_product_price/?pin=${delto}&id=${itemid}&quantity=${qty}`;
          const response2 = await axios.get(url2);
          setdelresponse({
            status: true,
            msg: "Delivery available on this location",
            color: "green",
            Delivery: response2.data.rate
          });
          setcheckloader(false);
          // setdelto("");
        } else {
          setdelresponse({ status: true, color: "red", msg: "delivery not Available" });
          setcheckloader(false);
        }

        // setTimeout(() => {
        //   setdelresponse({ status: false, msg: "" });
        // }, 4000);
      } catch (error) {
        console.log("error", error);
        setdelresponse({ status: true, color: "red", msg: "Delivery not Available" });
        setcheckloader(false)
      }

    }
  };

  const redirectfun = (linkpage) => {
    nvg(linkpage);
  };

  const incrementcart = () => {
    setqty(parseInt(qty) + 1);

  };
  const decrementcart = () => {
    if (qty > 1) {
      setqty(parseInt(qty) - 1);
    }
  };


  async function Cartvalueget() {
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
        'Content-Type': 'application/json',
      },
    };
    let url = `${process.env.REACT_APP_API_URL}homepageapi/CartCountOfUser`;
    try {
      const response = await axios.get(url, config);
      // setCartnumber(response.data.cart_count)
      dispatch(addItem(response.data.cart_count));

    } catch (error) {
      if (error.response.status == 401) {


      }
    }
  }


  async function Wishvalueget() {
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
        'Content-Type': 'application/json',
      },
    };
    let url56 = `${process.env.REACT_APP_API_URL}homepageapi/GetCountOfWishlist`;
    try {
      const response = await axios.get(url56, config);
      // console.log("first vvvbbbbbbnnnnn super response",response);
      // setWishlistnumber(response.data.wishlist_count)
      dispatch(addwishlist(response.data.wishlist_count));

    } catch (error) {
    }
  }




  const [addtocarttime, setaddtocarttime] = useState(false)
  const Addtocart = async (id) => {
    setaddtocarttime(true)
    if (popstatus == false) {
      const finalstock = Data.stock_record.num_in_stock - 0;

      if (finalstock > qty || finalstock == qty) {
        try {
          const formdata = new FormData();
          formdata.append("quantity", qty);
          formdata.append(
            "url",
            `${process.env.REACT_APP_API_URL}api/products/${id}/`
          );
          const config = {
            headers: {
              Authorization: `Bearer ${tokenvalue.access}`,
            },
          };
          let url = `${process.env.REACT_APP_API_URL}my_api/basket/add-product/`;
          const response = await axios.post(url, formdata, config);
          if (response.data?.id) {
            Cartvalueget()
            toast.success(' Add to Cart Successfully', {
              position: "top-center",
              autoClose: 3000,
              containerId: 'wishlist23'
            });

            setTimeout(() => {
              setaddtocarttime(false)
            }, 2000);
          }
        } catch (error) {
          setpopstatus(true)
          let existingToastId = toast.error(error.response.data.reason, {
            position: "top-center",
            autoClose: 2000,
            containerId: "addtocart"
          });
          setTimeout(() => {
            setpopstatus(false)
            toast.dismiss({ containerId: "addtocart" })
          }, 2000);
        }
      } else {
        setpopstatus(true)
        let existingToastId = toast.error(`Sorry! We don't have any more units for this item`, {
          position: "top-center",
          autoClose: 2000,
          containerId: "addtocart"
        });
        setTimeout(() => {
          setpopstatus(false)
          toast.dismiss({ containerId: "addtocart" })
        }, 2000);
      }
    }
  };


  const removewishlist = async (id) => {
    setaddtocarttime(true)
    try {
      const realone = wishlist.filter((item) => item.product_id == id);
      let url = `${process.env.REACT_APP_API_URL}homepageapi/DeleteProductFromWishlist/${realone[0].id}/`;
      const response = await axios.delete(url);
      if (response.data.message == "success") {
        // setpopstatus(true)
        Wishvalueget()
        toast.success(' Removed from your Wishlist', {
          position: "top-center",
          autoClose: 3000,
          containerId: 'wishlist23'
        });

        setTimeout(() => {
          Product_Detail(location.state.id, location.state.pname);
          setaddtocarttime(false)
        }, 2000);


      }
    } catch (error) {
      setloading(false)
    }
    // }
  };



  const Addtowishlist = async (id) => {
    setaddtocarttime(true)
    try {
      const formdata = new FormData();
      formdata.append(
        "url",
        `${process.env.REACT_APP_API_URL}api/products/${id}/`
      );
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      let url = `${process.env.REACT_APP_API_URL}homepageapi/add-wishlist-view/`;
      const response = await axios.post(url, formdata, config);
      if (response.data.message == "product sucessfully added to wishlist") {

        Wishvalueget()
        toast.success('Added to your Wishlist', {
          position: "top-center",
          autoClose: 2000,
          containerId: 'wishlistadd2300',

        });


        setTimeout(() => {
          fetchwishlist()
          Product_Detail(location.state.id, location.state.pname);
          setaddtocarttime(false)
        }, 2000);

      }
    } catch (error) {
      console.log("error", error);
    }
    // }
  };


  async function getcountries() {
    let url = `${process.env.REACT_APP_API_URL}api/countries/`;
    try {
      const response = await axios.get(url);
      setcountriesdata(response.data);
    } catch (error) { }
  }

  const [addloader, setaddloader] = useState(true)
  async function getaddress() {
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
        "Content-Type": "application/json",
      },
    };
    let url = `${process.env.REACT_APP_API_URL}homepageapi/address/list`;
    try {
      const response = await axios.get(url, config);
      if (response.data[0].id) {
        setaddressdataindex(response.data[0]);
        setdelto(response.data[0].postcode)
        // devto()
        setaddloader(false)
        // setaddressdataindex(response.data[response.data.length - 1])
      } else {
        setaddloader(false)
      }
    } catch (error) {
      setaddloader(false)
      // setloading(false)
      // console.log(error)
    }
  }






  async function Product_Detail(id, titlename) {
    setloading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
      },
    };
    let url = `${process.env.REACT_APP_API_URL}my_api/products/${id}`;
    const response = await axios.get(url, config);

    const existdata = response.data.arrayProd.filter((item) => item.title == titlename);
    const sortedImages = existdata[0].image.sort((a, b) => a.display_order - b.display_order);
    setData({ sortedImages, ...existdata[0] });
    setfixedData(response.data);
    getcountries()
    getaddress()
    const uniqueKeysSet = new Set();
    const uniqueProducts = response.data.arrayProd.filter((product) => {
      if (!uniqueKeysSet.has(product.id)) {
        uniqueKeysSet.add(product.id);
        return true;
      }
      return false;
    });

    const flattenedAttributes = uniqueProducts.flatMap(
      (child) => child.attributes
    );
    const groupedAttributes = flattenedAttributes.reduce(
      (acc, attribute) => {
        const { attribute__name, value_option__option } = attribute;
        acc[attribute__name] = acc[attribute__name] || [];
        acc[attribute__name].push(value_option__option);
        return acc;
      },
      {}
    );
    setattrlist(groupedAttributes);
    setviewimg(`${process.env.REACT_APP_API_URL}media/${sortedImages?.[0]?.original}`)
    setloading(false);

  }

  async function fetchwishlist() {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      setloading(true)
      let url = `${process.env.REACT_APP_API_URL}homepageapi/wishlist-deatail/`;
      const response = await axios.get(url, config);
      setwishlist(response.data);
    } catch (error) {
      setwishlist([]);
    }
  }



  useEffect(() => {

    if (location.state.id && location.state.pname) {

      async function Get_Related_Product(id) {
        let url = `${process.env.REACT_APP_API_URL}homepageapi/get-recomendeed-product/${id}`;
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
          },
        };
        const response = await axios.get(url, config);
        setData3(response?.data);
      }
      Recently_ViewAnd_Product_View(location.state.id)
      fetchwishlist()
      Product_Detail(location.state.id, location.state.pname);
      Get_Related_Product(location.state.id);
    }

  }, [location.state.id]);

  const checkAttribute = (name) => {
    const val = Data.attributes.find(attr => attr.attribute__name == name)?.value_option__option;
    return val;
  }

  const colorMap = {
    "Lime Green": "#32CD32",
    Brinjal: "#5D275D",
    "Ink Blue": "#003366",
    Coffee: "#6F4E37",
    Brick: "#CB4154",
    Yellow: "#FFFF00",
    "Bright Green": "#00FF00",
    Jade: "#00A86B",
    "Pista Green": "#93C572",
    Plum: "#8E4585",
    "Military Green": "#4B5320",
    "Flourescent Green": "#39FF14",
    Burgandy: "#800020",
    Poppy: "#E35335",
    Lavender: "#E6E6FA",
    Fuschia: "#FF00FF",
    "Bottle Green": "#006A4E",
    "Bright Maroon": "#B03060",
    "Rose Pink": "#FF66CC",
    "Baby Blue": "#89CFF0",
    Kiwi: "#8EE53F",
    Pink: "#FFC0CB",
    "Deep Maroon": "#5C0011",
  };

  const copyProductLink = async () => {
    const productUrl = `${window.location.origin}/productdetails/id=${productid}/pname=${encodeURIComponent(productpname)}`;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(productUrl);
      } else {
        // Fallback
        const textArea = document.createElement("textarea");
        textArea.value = productUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }

      alert("Product link copied!");
    } catch (err) {
      console.error(err);
      alert("Unable to copy link");
    }
  };
  const shareProduct = async () => {
    const productUrl = `${window.location.origin}/productdetails/id=${productid}/pname=${encodeURIComponent(productpname)}`;
 
    if (navigator.share) {
      try {
        await navigator.share({
          title: productpname,
          url: productUrl,
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(productUrl);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = productUrl;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }

        alert("Product link copied!");
      } catch (err) {
        console.error(err);
        alert("Unable to copy link");
      }
    }
  };



  const isMobile = window.innerWidth < 768;


  return loading == true || addloader == true ? (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {" "}
      <h2
        style={{
          textAlign: "center",
          paddingTop: "15px",
          fontWeight: "600",
          fontSize: "20px",
        }}
      >
        <Loader />
      </h2>
    </div>
  ) : (
    <>
      {/* {popstatus == true ? */}
      <div style={{ width: '100%', position: 'relative', display: addtocarttime == true ? 'flex' : 'none', justifyContent: 'center' }}>
        {addtocarttime == true ? <ToastContainer
          style={{
            display: popstatus === true ? 'block' : 'none',
            backgroundColor: `#${bgColor}`
          }}
          position="top-center"
          autoClose={2000}
          containerId={"addtocart"}

        /> : ''}

        {addtocarttime == true ? <ToastContainer
          position="top-center"
          autoClose={2000}
          containerId={"wishlist23"}

        /> : ''}

        {addtocarttime == true ? <ToastContainer
          position="top-center"
          autoClose={2000}
          containerId={"wishlistadd2300"}

        /> : ''}

      </div>
      {/* : ''}  */}

      <Header />

      {/* breadcrumb start */}
      <div className="breadcrumb-main marginfromtop">
        <div className="container m-0">
          <div className="row">
            <div className="col">
              <div
                className="breadcrumb-contain m-0"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingLeft: "5px",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  {/* <h2>product</h2> */}
                  <ul>
                    <li>
                      <a href="/home">home</a>
                    </li>
                    <li style={{ fontSize: "12px" }}>&gt;</li>
                    <li>
                      <p
                        onClick={() => {
                          nvg(`/category/${fixedData.paren_category == Data?.parent__categories__name ? Data.parent__categories__id : Data.parent__categories__id}/${fixedData.paren_category == Data?.parent__categories__name ? fixedData.paren_category : `${fixedData.paren_category} > ${Data.parent__categories__name}`}/${btoa('none')}`)
                        }}
                        style={{ cursor: "pointer", fontSize: "12px" }}
                      >
                        {fixedData.paren_category == Data?.parent__categories__name ? Data.parent__categories__name : ` ${fixedData.paren_category} > `}
                        {/* {location.state?.pagename} */}
                        {Data?.parent__categories__name}
                        {/* {fixedData.categories?.[0]} */}
                      </p>
                    </li>
                  </ul>
                </div>
                <div
                  className="header-contain"
                  style={{ padding: "8px 0px 0px 0px" }}
                >
                  <div
                    className="icon-block  twoicon"
                    style={{ width: "100%", display: "none" }}
                  >
                    <ul
                      className="theme-color"
                      style={{
                        width: "100%",
                        background: "",
                        justifyContent: "space-around",
                        paddingRight: "10px",
                      }}
                    >
                      <li
                        className=" icon-md-block"
                        onClick={() => redirectfun("/")}
                      >

                      </li>
                      <li></li>
                      <li
                        className="mobile-setting "
                        onClick={() => redirectfun("/order-history")}
                      ></li>
                      <li
                        className="mobile-wishlist item-count icon-desk-none"
                        onClick={() => redirectfun("/wishlist")}
                      >
                        <img
                          src="./images/mega-store/brand/heart.png"
                          className="newwidthpro hellopooja"
                          alt="heart"
                        />
                        <label
                          htmlFor=""
                          style={{ fontSize: "10px", margin: "0px" }}
                        >
                          Wishlist
                        </label>
                        <div
                          className="item-count-contain inverce"
                          style={{ top: "-4px", left: "9px", padding: '8px', backgroundColor: gobalvariable.wishlist > 0 ? `#${bgColor}` : '#8b8f8c' }}
                        >
                          {gobalvariable.wishlist}
                        </div>
                      </li>
                      <li
                        className="mobile-cart
                      item-count"
                        onClick={() => {
                          redirectfun("/cart");
                        }}
                      >
                        <img
                          src="./images/mega-store/brand/shopping-cart.png"
                          className="newwidthpro  hellopooja"
                          alt="cart"
                        />
                        <label
                          htmlFor=""
                          style={{ fontSize: "10px", margin: "0px" }}
                        >
                          Cart
                        </label>

                        <div
                          className="item-count-contain inverce"
                          style={{ top: "-4px", left: "9px", padding: '8px', backgroundColor: gobalvariable.cart > 0 ? `#${bgColor}` : '#8b8f8c' }}
                        >
                          {" "}
                          {gobalvariable.cart}{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* breadcrumb End */}
      {/* section start */}
      <section
        className="section-big-pt-space b-g-light"
        style={{ background: "white" }}
      >
        <div className="collection-wrapper">
          <div className="custom-container">
            <div className="row">
              <div className="col-lg-12 col-sm-12 col-xs-12">
                <div className="container-fluid">
                  {/* <div className="row">
                      <div className="col-xl-12">
                      </div>
                    </div> */}
                  <div
                    className="row"
                    style={{ display: "flex", alignItems: "flex-start" }}
                  >
                    <div className="col-lg-6 makestk">
                      <div className="row">
                        <div className="col-md-3 col-3 superpadding3">
                          <div
                            class="container-fluid px-lg-4 px-md-3 px-2"
                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                          >
                            {/* https://adminoneupv1.stackerbee.com/media/ */}

                            <div
                              style={{ padding: "0px 0px 5px 0px" }}
                              className="shirt"
                            >
                              {/* {console.log("fffff img",Data)} */}
                              <img
                                src={`${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[0]?.original.replace(searchString, '')}`}
                                onClick={() => {
                                  setviewimg(`${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[0]?.original.replace(searchString, '')}`);
                                }}
                                alt
                                style={{ aspectRatio: "1/1", objectFit: 'contain' }}
                                className="img-fluid  image_zoom_cls-0"
                              />
                            </div>
                            {Data?.sortedImages?.[1] ? (
                              <div
                                style={{ padding: "5px 0px" }}
                                className="shirt2"
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[1]?.original.replace(searchString, '')}`}
                                  onClick={() => {
                                    setviewimg(
                                      `${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[1]?.original.replace(searchString, '')}`
                                    );
                                  }}
                                  alt
                                  style={{ aspectRatio: "1/1", objectFit: 'contain' }}
                                  className="img-fluid  image_zoom_cls-1"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {Data?.sortedImages?.[2] ? (
                              <div
                                style={{ padding: "5px 0px" }}
                                className="shirt3"
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[2]?.original.replace(searchString, '')}`}
                                  onClick={() => {
                                    setviewimg(
                                      `${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[2]?.original.replace(searchString, '')}`
                                    );
                                  }}
                                  alt
                                  style={{ aspectRatio: "1/1", objectFit: 'contain' }}
                                  className="img-fluid  image_zoom_cls-2"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {Data?.sortedImages?.[3] ? (
                              <div
                                style={{ padding: "5px 0px" }}
                                className="shirt4"
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[3]?.original.replace(searchString, '')}`}
                                  onClick={() => {
                                    setviewimg(
                                      `${process.env.REACT_APP_API_URL}media/${Data?.sortedImages?.[3]?.original.replace(searchString, '')}`
                                    );
                                  }}
                                  alt
                                  style={{ aspectRatio: "1/1", objectFit: 'contain' }}
                                  className="img-fluid  image_zoom_cls-3"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-md-9 col-9">
                          <div className="product-slick ">
                            <div>
                              <ReactImageMagnify
                                {...{
                                  smallImage: {
                                    alt: 'Wristwatch by Versace',
                                    isFluidWidth: true,
                                    src: viewimg,
                                    width: 140,
                                    height: 200,
                                  },
                                  largeImage: {
                                    src: viewimg,
                                    width: 600,
                                    height: 800,
                                  },
                                  enlargedImagePosition: 'over',
                                  enlargedImageContainerDimensions: {
                                    width: '100%',
                                    height: '100%',
                                  },
                                  lensStyle: {
                                    backgroundColor: 'rgba(0,0,0,.6)',
                                  },
                                }}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 rtl-text p-0">
                      <div
                        className="product-right "
                        style={{
                          boxShadow: "0px 14px 40px 0px rgba(0, 0, 0, 0.12)",
                          borderRadius: "10px",
                          padding: "20px 17px",
                        }}
                      >
                        <div className="pro-group">
                          {/* {console.log("current data of product is here",Data)} */}
                          <h2 style={{ color: `#${textColor}` }}>{!Data?.attributes ? "" : Data?.attributes.filter(user => user.attribute__name.toUpperCase() == "BRAND").map((item, index) => (<span style={{ letterSpacing: '0px', fontWeight: "100", cursor: 'pointer' }} onClick={() => { nvg(`/categoryforbrand/${item.value_option__option}`) }}>{item.value_option__option}</span>))}</h2>
                          <h2 style={{ letterSpacing: '0px', fontWeight: "100" }} onClick={() => { checkAttribute() }} >{Data?.title} <span style={{ color: "red", letterSpacing: '0.4px', fontWeight: "100" }}>{(Data?.stock_record?.num_in_stock - 0) == 0 ? "(Out of Stock)" : ""}</span></h2>
                          <div className="revieu-box">
                            <ul className="pro-price">
                              <li
                                style={{
                                  color: "#000",
                                  // color: "#230BB3",
                                  fontWeight: "500",
                                  fontSize: "18px",
                                }}
                              >
                                {Data?.stock_record?.discount == 0 ? 'MRP:' : ''} {new Intl.NumberFormat("en-IN", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }).format(parseInt(Data?.stock_record?.price))}{Data?.stock_record?.discount == 0 ? '' : <span style={{ fontSize: '14px', color: '#c1c1c1', lineHeight: '20px', textDecoration: 'line-through', paddingLeft: '3px', margin: '0px', fontWeight: '100' }}> <span style={{ fontSize: '14px', color: '#c1c1c1', lineHeight: '20px', textDecoration: 'none', paddingLeft: '3px', margin: '0px', fontWeight: '100' }}>&nbsp;MRP:</span>  {new Intl.NumberFormat("en-IN", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }).format(parseInt(Data?.stock_record?.mrp))} </span>}{Data?.stock_record?.discount == 0 ? '' : <span style={{ fontSize: '14px', color: '#388e3c', lineHeight: '20px', paddingLeft: '2px', margin: '0px', fontWeight: '100', textDecoration: 'none' }}>{Data?.stock_record?.discount_type == "amount" ? `(₹${Data?.stock_record?.discount} off)` : `(${Data?.stock_record?.discount} %off)`}</span >}
                              </li>
                              <li
                                style={{ color: "black", fontSize: "11px", position: 'relative', top: '-3px', cursor: 'pointer' }}
                                onClick={() => {
                                  Data?.is_wishlist?.[0]?.is_wishlist == true ? removewishlist(Data.id) : Addtowishlist(Data.id);
                                }}
                              >
                                {" "}

                                {Data?.is_wishlist?.[0]?.is_wishlist == true ? <FaHeart size={19} color={`#${bgColor}`} /> : <FaRegHeart size={19} />}



                              </li>
                              <li
                                className="ms-2"
                                onClick={copyProductLink}
                                style={{
                                  cursor: "pointer",
                                  display: isMobile ? "none" : "inline-block",
                                }}
                              >
                                <i
                                  className="fa-regular fa-copy"
                                  style={{ color: "rgb(12, 183, 68)", fontSize: "16px" }}
                                ></i>
                              </li>

                              <li
                                className="ms-2"
                                onClick={shareProduct}
                                style={{
                                  cursor: "pointer",
                                  display: isMobile ? "inline-block" : "none",
                                }}
                              >
                                <i
                                  className="fa-solid fa-share-nodes"
                                  style={{ color: "rgb(12, 183, 68)", fontSize: "16px" }}
                                ></i>
                              </li>

                            </ul>
                          </div>
                          {Data?.stock_record?.discount == 0 ? '' : <ul className="pro-price" style={{ position: 'relative', top: '-10px' }}>
                            <li
                              style={{
                                color: "#000",
                                fontWeight: "500",
                                fontSize: "15px",
                                textTransform: 'capitalize'
                              }}
                            >You Save : {Data?.stock_record?.discount == 0 ? '' : <span style={{ fontSize: '14px', color: '#388e3c', lineHeight: '20px', paddingLeft: '2px', margin: '0px', fontWeight: '400', textDecoration: 'none' }}>{Data?.stock_record?.discount_type == "amount" ? `₹${parseInt(Data?.stock_record?.mrp) - parseInt(Data?.stock_record?.price)}` : `₹${parseInt(Data?.stock_record?.mrp) - parseInt(Data?.stock_record?.price)}`}</span >}</li>
                          </ul>}
                          <div>

                            {(Data?.stock_record?.num_in_stock - 0) < 10 && (Data?.stock_record?.num_in_stock - 0) > 0 ? <span style={{ color: 'crimson', textDecoration: 'none', fontWeight: '500', fontSize: '14px', position: 'relative', top: '-8px' }}>Hurry, Only {Data?.stock_record?.num_in_stock - 0} Left</span> : ""}

                          </div>
                        </div>
                        <div
                          id="selectSize"
                          className="pro-group addeffect-section product-description border-product d-flex"
                          style={{
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                          }}
                        >

                          {Data?.attributes
                            ? Object.entries(attrlist).map(
                              ([name, value]) => (

                                <div className="productdetailcontainer customwidth" style={{ display: name.toUpperCase() == "BRAND" ? "none" : "" }}>
                                  <h6 className="product-title mt-2">
                                    {name}
                                  </h6>
                                  <div className="size-box">
                                    <ul style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                      {name == "Color" || name == "color" ? <>
                                        {value.filter((value, index, self) => self.indexOf(value) === index).map((value2, index5) => (
                                          <li
                                            style={{
                                              background: colorMap[value2] || `${value2}`,
                                              borderRadius: '50%',
                                              width: '30px', // Fixed size setup karein
                                              height: '30px',
                                              margin: '4px',
                                              cursor: 'pointer',
                                             
                                              transform: checkAttribute(name) === value2 ? 'scale(1.2)' : 'scale(1)',
                                              transition: 'transform 0.2s ease',
                                            }}
                                            onClick={() => { getProductByAttribute(fixedData?.arrayProd, name, value2) }} >
                                            <div className="color-4"  >

                                            </div>
                                          </li>
                                        ))} </> : <>
                                        {sortsizefilter(value).filter((value, index, self) => self.indexOf(value) === index).map((value2, index5) => (
                                          <li
                                            className="px-2"
                                            style={{
                                              width: "fit-content",
                                              marginBottom: '2px',
                                              marginLeft: '2px',
                                              display: name == "Brand" ? index5 != 0 ? 'none' : 'none' : 'block',
                                              borderColor: checkAttribute(name) == value2 ? `#${bgColor}` : ``,
                                              fontWeight: checkAttribute(name) == value2 ? `600` : ``,
                                              color: checkAttribute(name) == value2 ? `#${bgColor}` : ``
                                            }}
                                            onClick={() => { getProductByAttribute(fixedData?.arrayProd, name, value2) }}
                                          >
                                            <a href="javascript:void(0)" style={{
                                              color: checkAttribute(name) == value2 ? `#${bgColor}` : ``
                                            }}>
                                              {value2}
                                            </a>
                                          </li>

                                        ))}</>}

                                    </ul>
                                  </div>
                                </div>
                              )
                            )
                            : ""}


                          <div className="productdetailcontainer " style={{ width: "100%" }}>
                            <h6 className="product-title mt-3">quantity</h6>
                            <div
                              className="qty-box gap"
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "",
                              }}
                            >
                              <div className="input-group">

                                <button
                                  type="button"
                                  onClick={() => {
                                    decrementcart();
                                  }}
                                >
                                  <i
                                    className="fa-solid fa-minus"
                                    // style={{ color: "#230bb3" }}
                                    style={{ color: `#${textColor}` }}
                                  />
                                </button>
                                <input
                                  className="qty-adj form-control"
                                  type="number"
                                  style={{ width: "44px", padding: "0.375rem 0.45rem" }}
                                  // readOnly
                                  onChange={(e) => {
                                    if (e.target.value === '' || parseInt(e.target.value) !== 0) {
                                      setqty(e.target.value);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    if (e.target.value === '' || parseInt(e.target.value) == 0) {
                                      setqty(1);
                                    }
                                  }}
                                  value={qty}
                                />
                                <button
                                  type="button"
                                  onClick={() => {
                                    incrementcart();
                                  }}
                                >
                                  <i
                                    className="fa-solid fa-plus"
                                    style={{ color: `#${textColor}` }}
                                  />
                                </button>
                              </div>

                              <div className="product-buttons" style={{ backgroundColor: `#${bgColor}`, color: `#${textColor}` }}>
                                {!addressdataindex?.postcode ? <a
                                  href="javascript:void(0) "
                                  data-bs-toggle="modal" data-bs-target="#exampleModaladdressone"
                                  style={{ backgroundColor: `#${bgColor}`, color: `#${textColor}`, padding: "9px 9px", }}

                                  id="cartEffect"
                                  className="btn cart-btn btn-normal tooltip-top"
                                  data-tippy-content="Add to cart"
                                >
                                  <i className="fa fa-shopping-cart" />
                                  add to cart
                                </a> : <a
                                  href="javascript:void(0) "
                                  onClick={() => (Data?.stock_record?.num_in_stock - 0) == 0 ? console.log("first test 2") : Data?.is_stockrecords !== 0 ? Addtocart(Data.id) : console.log("first test 1")}
                                  style={{ backgroundColor: `#${bgColor}`, color: `#${textColor}`, padding: "9px 9px", }}


                                  id="cartEffect"
                                  className="btn cart-btn btn-normal tooltip-top"
                                  data-tippy-content="Add to cart"
                                >
                                  <i className="fa fa-shopping-cart" />
                                  {(Data?.stock_record?.num_in_stock - 0) == 0 ? 'Out of Stock' : 'add to cart'}
                                </a>}
                              </div>
                              {/* </span> */}
                            </div>
                          </div>

                          <div
                            className="productdetailcontainer w-lg-50 w-xs-100 d-flex"
                            style={{
                              flexDirection: "column",
                              alignItems: "end",
                              justifyContent: "center",
                              marginTop: "10px",
                            }}
                          >
                            <div className="pro-group">
                              <h6 className="product-title endlinetext">
                                Deliver To{" "}
                                <img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/icon/Place.png`} alt="404" />{" "}
                              </h6>
                              <div className="delivery-detail">
                                <div className="delivery-detail-contian">
                                  <div className="input-group">
                                    <input
                                      type="phone"
                                      name="pincode"
                                      className="form-control makeitsmall"
                                      minLength={6}
                                      maxLength={6}
                                      value={delto}
                                      style={{ padding: "0px 0.75rem" }}
                                      onChange={(e) => {
                                        setdelto(e.target.value.replace(/[^0-9]/gi, ""));
                                      }}
                                      placeholder="Enter Pincode for delivery" />

                                  </div>
                                  <button
                                    ref={checkpin}
                                    type="button"
                                    style={{
                                      background: "#CFCFCF",
                                      borderRadius: "3px",
                                      color: "black",
                                      fontWeight: "700",
                                      padding: "8px 15px",
                                      fontSize: "13px",
                                    }}
                                    onClick={() => {
                                      devto(Data.id);
                                    }}
                                    className="btn btn-md"
                                  >
                                    Check
                                  </button>
                                </div>
                                {checkloader == true ? <p> Loading...</p> : <p style={{ color: delresponse["color"] == "red" ? "red" : "green" }}>
                                  {delresponse["status"] == true
                                    ? <>{delresponse["msg"]}  {delresponse["Delivery"] ? <>|| ₹{delresponse["Delivery"]}</> : ''}</>
                                    : ""}
                                </p>}
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div
                        className="product-right "
                        style={{
                          marginTop: "20px",
                          boxShadow: "0px 14px 40px 0px rgba(0, 0, 0, 0.12)",
                          borderRadius: "10px",
                          padding: "20px 17px",
                        }}
                      >
                        <div
                          id="selectSize"
                          className="pro-group addeffect-section product-description border-product d-flex"
                          style={{
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="productdetailcontainer w-100">
                            <h5 className="product-title ">Product Specifications</h5>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: Data?.specifications,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="product-right "
                        style={{
                          marginTop: "20px",
                          boxShadow: "0px 14px 40px 0px rgba(0, 0, 0, 0.12)",
                          borderRadius: "10px",
                          padding: "20px 17px",
                        }}
                      >
                        <div
                          id="selectSize"
                          className="pro-group addeffect-section product-description border-product d-flex"
                          style={{
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="productdetailcontainer w-100">
                            <h5 className="product-title ">Product Details</h5>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: fixedData?.description,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {Data3[0]?.recommended_products__children ? (
        <section className="section-big-py-space  ratio_asos b-g-light">
          <div className="custom-container">
            <div className="row">
              <div className="col-12 product-related">
                <h2>related products</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12 product">
                <div className="product-slide-6 product-m no-arrow">
                  <OwlCarousel
                    className="owl-theme"
                    style={{ width: "100%", height: "100%" }}
                    {...options5}
                  >

                    {Data3.map((item) => (
                      <Relatedowl item={item} catid={location.state?.categoryid}
                        catpage={location.state?.pagename} />
                    ))}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}


      {RecentlyViewData[0]?.id ? (
        <section
          className="section-big-py-space  ratio_asos b-g-light"
          style={{ display: RecentlyViewData[0]?.id ? "block" : "none" }}
        >
          <div className="custom-container">
            <div className="row">
              <div className="col-12 product-related">
                <h2>Recently Viewed</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12 product">
                <div
                  className="product-slide-6 product-m no-arrow"
                  style={{ display: RecentlyViewData[0]?.id ? "block" : "none" }}
                >
                  <OwlCarousel
                    className="owl-theme"
                    style={{ width: "100%", height: "100%" }}
                    {...options5}
                  >
                    {RecentlyViewData.map((item, index) => (
                      <Recentlyowl
                        Data={item}
                        catid={location.state?.categoryid}
                        catpage={location.state?.pagename}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseleave}
                        colorState={hoverRef}
                      />
                    )
                    )}

                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : ""}

      <Footer />



      <div class="modal fade" id="exampleModaladdressone" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" style={{ maxWidth: '770px' }}>
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Add Address</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <Formik
                initialValues={{
                  first_name: '',
                  last_name: '',
                  email: '',
                  mobile: '',
                  address1: '',
                  address2: '',
                  country: '',
                  countryurl: '',
                  state: '',
                  city: '',
                  pincode: '',
                  address_type: 'HOME',
                }}
                validationSchema={checkoutvalidation}
                onSubmit={(values, { setFieldError }) => {
                  createaddress(values, setFieldError);
                }}
              >
                {({
                  values,
                  errors,
                  handleSubmit,
                  touched,
                  setFieldValue,
                  setFieldError,
                  handleChange
                }) => (
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="row check-out ">
                      <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                        <label className=" acounttitle field-label m-0">
                          Address Type
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        <div className="d-flex" style={{ gap: '10px' }}>
                          <div>
                            <label style={{ display: 'flex', alignItems: 'center' }}>
                              <input
                                type="radio"
                                name="address_type"
                                value="HOME"
                                onChange={handleChange}
                                checked={values.address_type == 'HOME'}
                              />
                              HOME
                            </label>
                          </div>
                          <div>
                            <label style={{ display: 'flex', alignItems: 'center' }}>
                              <input
                                type="radio"
                                name="address_type"
                                value="OFFICE"
                                onChange={handleChange}
                                checked={values.address_type == 'OFFICE'}
                              />
                              OFFICE
                            </label>
                          </div>
                          <div>
                            <label style={{ display: 'flex', alignItems: 'center' }}>
                              <input
                                type="radio"
                                name="address_type"
                                value="OTHER"
                                onChange={handleChange}
                                checked={values.address_type == 'OTHER'}
                              />
                              OTHER
                            </label>
                          </div></div>
                        <div className="error">
                          {errors.address_type && touched.address_type ? (
                            <p style={{ color: "red" }}>
                              {errors.address_type}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle m-0">
                          First Name <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        {/* <input type="text" name="field-name" placeholder='First Name' /> */}

                        <Field
                          type="text"
                          name="first_name"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your First Name"
                          value={values?.first_name}
                        />
                        <div className="error">
                          {errors.first_name && touched.first_name ? (
                            <p style={{ color: "red" }}>
                              {errors.first_name}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle m-0">
                          Last Name
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        {/* <input type="text" name="field-name" placeholder='Last Name' /> */}
                        <Field
                          name="last_name"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Last Name"
                          value={values?.last_name}
                        />
                        <div className="error">
                          {errors.last_name && touched.last_name ? (
                            <p style={{ color: "red" }}>
                              {errors.last_name}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle field-label m-0">
                          Phone
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        {/* <input type="text" name="field-name" placeholder='Phone' /> */}
                        <Field
                          name="mobile"
                          type="number"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your Mobile. No"
                          value={values?.mobile}
                        />
                        <div className="error">
                          {errors.mobile && touched.mobile ? (
                            <p style={{ color: "red" }}>
                              {errors.mobile}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle field-label m-0">
                          Email Address
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        {/* <input type="text" name="field-name" placeholder='Email'/> */}
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Email Address"
                          value={values?.email}
                        />
                        <div className="error">
                          {errors.email && touched.email ? (
                            <p style={{ color: "red" }}>
                              {errors.email}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0">
                          Address
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        <Field
                          name="address1"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="House number and street name"
                          value={values.address1}
                        />
                        <div className="error">
                          {errors.address1 && touched.address1 ? (
                            <p style={{ color: "red" }}>
                              {errors.address1}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0">
                          Address 2
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        <Field
                          name="address2"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control mt-2"
                          placeholder="Apartment, suite, unit etc. (optional)"
                          value={values.address2}
                        />
                        <div className="error">
                          {errors.address2 && touched.address2 ? (
                            <p style={{ color: "red" }}>
                              {errors.address2}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                        <label className=" acounttitle field-label m-0">
                          Postal Code
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        <Field
                          name="pincode"
                          type="number"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your Pincode"
                          value={values.pincode}
                          minLength={6}
                          maxLength={6}
                          onChange={(e) => {
                            setFieldValue(
                              "pincode",
                              e.target.value.replace(/[^0-9\ ]/gi, "")
                            );
                            fetchstateandcity(
                              e.target.value.replace(/[^0-9\ ]/gi, ""),
                              setFieldError,
                              setFieldValue
                            );
                          }}
                        />
                        <div className="error">
                          {errors.pincode && touched.pincode ? (
                            <p style={{ color: "red" }}>
                              {errors.pincode}
                            </p>
                          ) : null}
                        </div>
                      </div>



                      {values.state !== '' && values.state !== null && cityna == 'NA' ? <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0">
                          City
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        {/* <input type="text" name="field-name" placeholder="City" /> */}
                        <Field
                          name="city"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your City"
                          value={values.city}
                        />
                        <div className="error">
                          {errors.city && touched.city ? (
                            <p style={{ color: "red" }}>
                              {errors.city}
                            </p>
                          ) : null}
                        </div>
                      </div> : <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0">
                          City
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>

                        <Field
                          name="city"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your City"
                          readOnly
                          value={values.city}
                        />
                        <div className="error">
                          {errors.city && touched.city ? (
                            <p style={{ color: "red" }}>
                              {errors.city}
                            </p>
                          ) : null}
                        </div>
                      </div>}


                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0">
                          State
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        <Field
                          name="state"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your State"
                          readOnly
                          value={values.state}
                        />
                        <div className="error">
                          {errors.state && touched.state ? (
                            <p style={{ color: "red" }}>
                              {errors.state}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0">
                          Country
                          <span style={{ color: 'red', fontSize: '13px' }}> *</span>
                        </label>
                        <Field
                          name="country"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Country"
                          readOnly
                          value={values.country}
                        />
                        <Field
                          name="countryurl"
                          type="hidden"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Country"
                          readOnly
                          value={values.countryurl}
                        />
                        <div className="error">
                          {errors.country && touched.country ? (
                            <p style={{ color: "red" }}>
                              {errors.country}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">

                        <div className="payment-box">
                          <div className="text-left" style={{ display: 'flex', justifyContent: 'end', gap: '4px' }}>
                            <button
                              type="button"
                              style={{ fontSize: "12px", background: '#bdbfc0', color: '#000' }}
                              className="btn-normal btn"
                              data-bs-dismiss="modal" aria-label="Close"
                              ref={buttonRef}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              style={{ fontSize: "12px", backgroundColor: `#${bgColor}` }}
                              className="btn-normal btn"
                            >
                              Save
                            </button>
                          </div>
                        </div>

                      </div>



                      <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">

                        <div class="alert alert-success" role="alert" style={{ display: addressstatus == true ? "block" : "none" }}>
                          Address Created Successfully
                        </div>

                      </div>


                    </div>
                  </Form>
                )}
              </Formik>

            </div>
            {/* <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> */}
          </div>
        </div>
      </div>

    </>
  );
}

export default Productdetails;
